const commonColors = {
  error: {
    main: '#DB4646',
    veryLight: '#FBEEEE',
  },
  warning: {
    main: '#FCB428',
    veryLight: '#FFF8EA',
  },
  success: {
    main: '#2CCD76',
    veryLight: '#EBFBF2',
  },
  favorite: {
    main: '#F36C8D',
    veryLight: '#FFF5F8',
  },
  convert: {
    main: '#FF7C50',
    veryLight: '#FFC5B1',
  },
  green: {
    veryLight: '#F0FBE3',
    main: '#BEF17D',
  },
  pink: {
    veryLight: '#FAF0FB',
    main: '#E5B6EA',
  },
  aqua: {
    veryLight: '#EAF7F9',
    main: '#1998AA',
  },
  purple: {
    veryLight: '#F5EAF0',
    main: '#97286B',
  },
  blue: {
    veryLight: '#F1F9FD',
    main: '#B8DFEF',
  },
};

const grey = {
  50: '#F9F9FF',
  100: '#F4F4F9',
  200: '#ECECF1',
  300: '#DDDDE3',
  400: '#BABABF',
  500: '#9B9BA0',
  600: '#727277',
  700: '#5E5E63',
  800: '#404044',
  900: '#1F1F23',
  A100: '#F4F4F9',
  A200: '#ECECF1',
  A400: '#BABABF',
  A700: '#5E5E63',
};

const Colors = {
  primary: {
    main: '#0E5057',
    veryDark: '#062528',
    veryLight: '#E8F1F2',
  },
  secondary: {
    main: '#008565',
    veryDark: '#063C2F',
    veryLight: '#E9F2F0',
  },
  info: {
    main: '#668DF0',
    veryLight: '#F0F4FF',
  },
  grey,
  ...commonColors,
};

export const InternalColors = {
  primary: {
    main: '#073860',
    veryDark: '#00192D',
    veryLight: '#CFEAFF',
  },
  secondary: {
    main: '#2A7EC3',
    veryDark: '#133C5F',
    veryLight: '#E5F3FF',
  },
  info: {
    main: '#81C6FF',
    veryLight: '#F0F4FF',
  },
  ...commonColors,

};

export const LightModeColors = {
  text: {
    primary: '#1F1F23',
    secondary: '#1F1F23C9',
  },
  inverted: {
    main: '#1F1F23',
    contrastText: '#FFF',
  },
};
export const DarkModeColors = {
  text: {
    primary: '#FFF',
  },
  inverted: {
    main: '#FFF',
    contrastText: '#1F1F23',
  },
};

const repeat = (firstArgs, func, times) => {
  let result = func(firstArgs);
  for (let i = 1; i < times; i += 1) {
    result = func(result);
  }
  return result;
};

export function augmentCustomColors(theme) {
  const updatedPalette = Object.fromEntries(Object.entries(theme.palette).map(([color, value]) => {
    if (typeof value !== 'object' || !value.main) return [color, value];
    const { light, dark } = theme.palette.augmentColor({ color: value });
    const { light: veryLight } = repeat({ light }, ({ light: lighter }) => (
      theme.palette.augmentColor({ color: { main: lighter } })
    ), 8);
    const { dark: veryDark } = repeat({ dark }, ({ dark: darker }) => (
      theme.palette.augmentColor({ color: { main: darker } })
    ), 2);
    return [color, {
      veryLight,
      light,
      dark,
      veryDark,
      ...value,
    }];
  }));

  return {
    ...theme,
    palette: {
      ...updatedPalette,
      grey: {
        ...updatedPalette.grey,
        ...grey,
      },
    },
  };
}

export default Colors;
